export default function BdFlagIcon() {
  return (
    <svg
      width="45"
      height="27"
      viewBox="0 0 45 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0H45V27H0V0Z" fill="#207E7D" />
      <circle cx="20.2492" cy="13.5" r="8.55" fill="#DF0000" />
    </svg>
  );
}
